import { Link } from 'react-router-dom';

export default function CaravanStorageLanding() {
  return (
    <div className="min-h-screen bg-white font-sans">
      {/* SECTION 1 — HERO */}
      <section
        className="relative min-h-screen flex flex-col justify-center"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Australian%20suburban%20driveway%20with%20caravan%20parked%20securely%20beside%20house%2C%20wide%20concrete%20hardstand%2C%20sunny%20day%2C%20residential%20neighborhood%2C%20clean%20modern%20home%20exterior%2C%20clear%20blue%20sky%2C%20well-maintained%20property%2C%20natural%20lighting%2C%20warm%20summer%20atmosphere%2C%20Australian%20architecture%20style%20brick%20home%20with%20side%20access%20to%20backyard&width=1920&height=1080&seq=cs-hero-001&orientation=landscape)`,
          backgroundSize: 'cover',
          backgroundPosition: 'center 60%',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/80 to-blue-700/60" />
        <div className="relative w-full max-w-3xl mx-auto px-6 py-20 text-center">
          <div className="inline-block bg-yellow-400 text-yellow-900 text-xs md:text-base font-bold px-4 py-2 md:px-6 md:py-3 rounded-full mb-8">
            Council Parking Bans Are Forcing Storage Demand
          </div>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white leading-tight mb-6">
            Got a garage, driveway or backyard? Earn $150–$350+ per month storing caravans and boats
          </h1>
          <p className="text-xl md:text-2xl text-white mb-10 max-w-xl mx-auto">
            Councils across Australia are banning caravans and boats from streets. Owners need secure local storage — and they&apos;ll pay monthly for it.
          </p>
          <Link
            to="/signup"
            className="inline-block bg-yellow-400 hover:bg-yellow-300 text-[#78350F] font-bold text-xl px-10 py-5 rounded-2xl transition-all cursor-pointer whitespace-nowrap"
          >
            List My Space Free
          </Link>
          <p className="text-white text-xs md:text-2xl font-semibold mt-6">
            Free to list · Takes 10 minutes · Cancel anytime
          </p>
        </div>
      </section>

      {/* SECTION 2 — THE OPPORTUNITY */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-center text-2xl font-bold text-gray-700 uppercase tracking-wider mb-4">
            Why now is the perfect time to list
          </h2>
          <div className="flex items-center justify-center gap-2 mt-3 mb-10">
            <span className="inline-flex items-center gap-2 bg-teal-50 border border-teal-200 text-teal-800 text-base font-semibold px-5 py-3 rounded-full">
              <i className="ri-percent-line text-[#14B8A6]"></i>
              Council bans are creating urgent demand for private storage across Australia
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-2xl p-8 border border-gray-100 text-center">
              <div className="w-14 h-14 mx-auto mb-5 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-government-line text-[#14B8A6] text-2xl"></i>
              </div>
              <div className="text-3xl font-extrabold text-gray-900 mb-2">100,000+</div>
              <div className="text-gray-500 font-medium">Caravans affected by council street parking bans</div>
            </div>
            <div className="bg-white rounded-2xl p-8 border border-gray-100 text-center">
              <div className="w-14 h-14 mx-auto mb-5 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-money-dollar-circle-line text-[#14B8A6] text-2xl"></i>
              </div>
              <div className="text-3xl font-extrabold text-gray-900 mb-2">$150–$350</div>
              <div className="text-gray-500 font-medium">Per month for a secure hardstand or driveway spot</div>
            </div>
            <div className="bg-white rounded-2xl p-8 border border-gray-100 text-center">
              <div className="w-14 h-14 mx-auto mb-5 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-calendar-check-line text-[#14B8A6] text-2xl"></i>
              </div>
              <div className="text-3xl font-extrabold text-gray-900 mb-2">12 months</div>
              <div className="text-gray-500 font-medium">Average storage rental duration — reliable recurring income</div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3 — WHAT SPACES QUALIFY */}
      <section className="py-20 md:py-28 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-center text-3xl md:text-4xl font-bold text-gray-900 mb-14">
            What spaces work for caravan and boat storage?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="bg-white rounded-xl p-6 flex items-start gap-4">
              <div className="w-12 h-12 flex-shrink-0 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-home-4-line text-[#14B8A6] text-xl"></i>
              </div>
              <div>
                <div className="text-gray-900 font-bold text-lg mb-1">Garage or Shed</div>
                <div className="text-gray-500">Lock-up or open, single or double</div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 flex items-start gap-4">
              <div className="w-12 h-12 flex-shrink-0 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-road-map-line text-[#14B8A6] text-xl"></i>
              </div>
              <div>
                <div className="text-gray-900 font-bold text-lg mb-1">Driveway or Hardstand</div>
                <div className="text-gray-500">Concrete or gravel, side access ideal</div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 flex items-start gap-4">
              <div className="w-12 h-12 flex-shrink-0 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-landscape-line text-[#14B8A6] text-xl"></i>
              </div>
              <div>
                <div className="text-gray-900 font-bold text-lg mb-1">Backyard or Side Yard</div>
                <div className="text-gray-500">Flat ground, accessible gate entry</div>
              </div>
            </div>
            <div className="bg-white rounded-xl p-6 flex items-start gap-4">
              <div className="w-12 h-12 flex-shrink-0 bg-teal-100 rounded-xl flex items-center justify-center">
                <i className="ri-building-line text-[#14B8A6] text-xl"></i>
              </div>
              <div>
                <div className="text-gray-900 font-bold text-lg mb-1">Commercial Yard</div>
                <div className="text-gray-500">Vacant lot, business premises after hours</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 4 — HOW IT WORKS */}
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-14">
            List in 10 minutes
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div className="flex flex-col items-center">
              <div className="w-14 h-14 bg-[#14B8A6] text-white text-2xl font-bold rounded-full flex items-center justify-center mb-5">
                1
              </div>
              <p className="text-gray-700 font-medium">Create your free account</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-14 h-14 bg-[#14B8A6] text-white text-2xl font-bold rounded-full flex items-center justify-center mb-5">
                2
              </div>
              <p className="text-gray-700 font-medium">Add photos and set your monthly price</p>
            </div>
            <div className="flex flex-col items-center">
              <div className="w-14 h-14 bg-[#14B8A6] text-white text-2xl font-bold rounded-full flex items-center justify-center mb-5">
                3
              </div>
              <p className="text-gray-700 font-medium">Get paid every month direct to your bank</p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 5 — TRUST */}
      <section className="py-20 md:py-28 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="flex items-center gap-4 bg-white rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-shield-check-line text-[#14B8A6] text-2xl"></i>
              </div>
              <span className="text-gray-900 font-bold text-base">All renters ID-verified</span>
            </div>
            <div className="flex items-center gap-4 bg-white rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-bank-card-line text-[#14B8A6] text-2xl"></i>
              </div>
              <span className="text-gray-900 font-bold text-base">Secure monthly payments</span>
            </div>
            <div className="flex items-center gap-4 bg-white rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-check-double-line text-[#14B8A6] text-2xl"></i>
              </div>
              <span className="text-gray-900 font-bold text-base">You approve every booking</span>
            </div>
            <div className="flex items-center gap-4 bg-white rounded-xl p-6">
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0">
                <i className="ri-customer-service-line text-[#14B8A6] text-2xl"></i>
              </div>
              <span className="text-gray-900 font-bold text-base">Stashly support 7 days a week</span>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — BOTTOM CTA */}
      <section className="py-24 md:py-32 bg-[#14B8A6]">
        <div className="max-w-2xl mx-auto px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Start earning from your spare space today
          </h2>
          <p className="text-teal-50 text-lg mb-10">
            Free to list. No lock-in. Join hosts across Australia earning monthly income from caravans, boats and RV storage.
          </p>
          <Link
            to="/signup"
            className="inline-block bg-yellow-400 hover:bg-yellow-300 text-[#78350F] font-bold text-xl px-10 py-5 rounded-2xl transition-all cursor-pointer whitespace-nowrap"
          >
            List My Space Free
          </Link>
          <p className="text-white/80 text-sm mt-6">
            Stashly takes 10% — you keep 90% of everything you earn. No hidden fees.
          </p>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="bg-gray-900 py-6 text-center text-gray-500 text-sm">
        &copy; 2026 Stashly Technologies Pty Ltd ·{' '}
        <Link to="/terms" className="hover:text-white transition-colors">
          Terms
        </Link>{' '}
        ·{' '}
        <Link to="/privacy" className="hover:text-white transition-colors">
          Privacy
        </Link>
      </footer>
    </div>
  );
}
